import React from "react";
import { PiUserCircleThin } from "react-icons/pi";

const ChatMessage = ({ name, message }) => {
  return (
    <div className="flex items-center m-3">
      <PiUserCircleThin className="cursor-pointer" size={32} />
      <span className="px-2 font-bold">{name}:</span>
      <span>{message}</span>
    </div>
  );
};

export default ChatMessage;
